import { html } from "lit";
var icon_thumbsDown_default = () => html`
  <svg stroke-fill viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg">
    <g stroke-width="2" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
      <path
        d="M6.2 2.73c.6 0 1.21-.1 1.8-.26l4.2-1.2A6.93 6.93 0 0 1 14.1 1h5.65c3.56 0 6.54 2.7 6.9 6.24l.34 5.9a5.2 5.2 0 0 1-3.93 5.3l-1.68.37c-.77.2-1.31.89-1.31 1.68v3.91a2.6 2.6 0 0 1-5.2 0v-1.8a8.67 8.67 0 0 0-8.67-8.66V2.74Z" />
      <path d="M1 16.6h5.2V1H1z" />
    </g>
  </svg>
`;
export {
  icon_thumbsDown_default as default
};
//# sourceMappingURL=icon-thumbsDown.js.map
